import { render, staticRenderFns } from "./TextCounter.vue?vue&type=template&id=9ef6ccb8"
import script from "./TextCounter.vue?vue&type=script&lang=js"
export * from "./TextCounter.vue?vue&type=script&lang=js"
import style0 from "./TextCounter.vue?vue&type=style&index=0&id=9ef6ccb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports